import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { FormControlEx } from '../../../core/component/forms/form-control';
import { SubleaseRequest } from '../../model/sublease-request';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';

@Component({
    selector: 'app-sublease-request-form',
    templateUrl: './sublease-request-form.component.html',
    styleUrls: ['./sublease-request-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SubleaseRequestFormComponent implements OnDestroy, OnInit {
  constructor(
    private _fb: FormBuilder,
    protected fcf: FormControlExFactory
  ) {}

  @Input() subleaseRequest: SubleaseRequest;
  @Output() completed = new EventEmitter<boolean>();

  public get created(): string {
    return this.subleaseRequest.created.toLocaleDateString();
  }

  private _subscription: Subscription = new Subscription();
  form: FormGroup;

  ngOnDestroy() {
    if (this._subscription) {
      this._subscription.unsubscribe();
      this._subscription = null;
    }
  }
  ngOnInit() {
    this.form = this._fb.group({
      created: this.fcf.createReadonly('SUBLEASE_REQUEST.CREATED_DATE', this.subleaseRequest.created),
      decisionDate: this.fcf.create('SUBLEASE_REQUEST.DECISION_DATE', this.subleaseRequest.decisionDate),
      decision: this.fcf.create('SUBLEASE_REQUEST.DECISION', this.subleaseRequest.decision),
      fromDate: this._fb.group({}),
      toDate: this._fb.group({}),
      reason: this.fcf.create('SUBLEASE_REQUEST.REASON', this.subleaseRequest.reason, Validators.maxLength(400)),
      subleaseeName: this.fcf.create('SUBLEASE_REQUEST.SUBLEASEE_NAME', this.subleaseRequest.subleaseeName, [
        Validators.required,
        Validators.maxLength(200),
      ]),
      subleaseeEmail: this.fcf.createEmail('SUBLEASE_REQUEST.SUBLEASEE_EMAIL', this.subleaseRequest.subleaseeEmail),
      subleaseePhone: this.fcf.create('SUBLEASE_REQUEST.SUBLEASEE_PHONE', this.subleaseRequest.subleaseePhone),
      contact: this._fb.group({}),
      subleaseeCurrentAddress: this._fb.group({}),
      addressDuringSublease: this._fb.group({}),
    });
  }

  cancel() {
    this.completed.emit(false);
  }

  onSubmit() {
    this.form.markAllAsTouched();
    if (this.form.invalid) return;

    if (this.form.pristine) {
      this.completed.emit(false);
    } else {
      Object.assign(this.subleaseRequest, this.form.value);
      this.completed.emit(true);
    }
  }
}
